// pages/PrivacyPolicy/index.jsx
import React, { useEffect } from 'react';
import { Container } from '../../styles/components';
import {
    PolicyWrapper,
    PolicyHeader,
    PolicyContent,
    Section,
    SubSection
} from './styles';
import useNavbar from '../../hooks/useNavbar';

const PrivacyPolicy = () => {
    const { setIsTransparent } = useNavbar();

    useEffect(() => {
        setIsTransparent(false);
        return () => setIsTransparent(true);
    }, [setIsTransparent]);

    return (
        <PolicyWrapper>
            <PolicyHeader>
                <Container>
                    <h1>Privacy Policy</h1>
                    <p>Last updated: January 19, 2025</p>
                </Container>
            </PolicyHeader>

            <Container>
                <PolicyContent>
                    <Section>
                        <h2>1. Introduction</h2>
                        <p>
                            At Le Petit Photography, we take your privacy seriously. This Privacy Policy explains how we collect, 
                            use, disclose, and safeguard your information when you use our photography services and website.
                        </p>
                    </Section>

                    <Section>
                        <h2>2. Information We Collect</h2>
                        <SubSection>
                            <h3>2.1 Personal Information</h3>
                            <p>We collect information that you provide directly to us, including:</p>
                            <ul>
                                <li>Name and contact information</li>
                                <li>Email address</li>
                                <li>Phone number</li>
                                <li>Billing and payment information</li>
                                <li>Photos and session preferences</li>
                                <li>Children's age and names (for photography sessions)</li>
                            </ul>
                        </SubSection>

                        <SubSection>
                            <h3>2.2 Usage Information</h3>
                            <p>We automatically collect certain information when you visit our website:</p>
                            <ul>
                                <li>IP address and device information</li>
                                <li>Browser type and settings</li>
                                <li>Website usage data</li>
                                <li>Cookies and similar technologies</li>
                            </ul>
                        </SubSection>
                    </Section>

                    <Section>
                        <h2>3. How We Use Your Information</h2>
                        <p>We use the collected information for various purposes:</p>
                        <ul>
                            <li>Provide and manage photography services</li>
                            <li>Process payments and subscriptions</li>
                            <li>Send service updates and notifications</li>
                            <li>Improve our services and website</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </Section>

                    <Section>
                        <h2>4. Information Sharing</h2>
                        <p>We may share your information with:</p>
                        <ul>
                            <li>Service providers and business partners</li>
                            <li>Payment processors</li>
                            <li>Legal authorities when required by law</li>
                        </ul>
                    </Section>

                    <Section>
                        <h2>5. Data Security</h2>
                        <p>
                            We implement appropriate security measures to protect your personal information. 
                            However, no method of transmission over the internet is 100% secure.
                        </p>
                    </Section>

                    <Section>
                        <h2>6. Your Rights</h2>
                        <p>You have the right to:</p>
                        <ul>
                            <li>Access your personal information</li>
                            <li>Correct inaccurate data</li>
                            <li>Request deletion of your data</li>
                            <li>Opt-out of marketing communications</li>
                        </ul>
                    </Section>

                    <Section>
                        <h2>7. Children's Privacy</h2>
                        <p>
                            We collect information about children only with parental consent and 
                            for the specific purpose of providing photography services.
                        </p>
                    </Section>

                    <Section>
                        <h2>8. Changes to This Policy</h2>
                        <p>
                            We may update this Privacy Policy from time to time. We will notify 
                            you of any changes by posting the new policy on this page.
                        </p>
                    </Section>

                    <Section>
                        <h2>9. Contact Us</h2>
                        <p>
                            If you have any questions about this Privacy Policy, please contact us at:
                        </p>
                        <ul>
                            <li>Email: lepetitbylenscraft@gmail.com</li>
                            <li>Phone: +94 77 771 5439</li>
                            <li>Address: Maeliya, Ja-Ela, Sri Lanka.</li>
                        </ul>
                    </Section>
                </PolicyContent>
            </Container>
        </PolicyWrapper>
    );
};

export default PrivacyPolicy;